import { InvoiceCells } from 'pages/app/billing/invoices/table-data/types.ts'
import { Modal } from '@boltenergy-be/design-system'
import Link from 'components/link/Link.tsx'
import styles from './InvoiceEntryModal.module.scss'
import { InvoiceEntryModalProps } from './types.ts'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'utils/tracking.ts'

const InvoiceEntryModal = ({ entry, ...modalProps }: InvoiceEntryModalProps) => {
  // i18n
  const { t } = useTranslation('invoices')

  // Constants
  const pdfUrl = entry?.[InvoiceCells.DOWNLOAD_ACTION]?.rawData?.pdf
  const peppolUrl = entry?.[InvoiceCells.DOWNLOAD_ACTION]?.rawData?.xml

  return (
    <Modal
      {...modalProps}
      title={entry?.[InvoiceCells.INVOICE_NUMBER]?.rawData ? `#${entry[InvoiceCells.INVOICE_NUMBER]?.rawData}` : ''}
      className={styles.modal}
    >
      {entry ? (
        <>
          <div className={styles.content}>
            <small className="text-subdued">{entry[InvoiceCells.DOCUMENT_TYPE]?.content}</small>
            <small className="text-subdued">
              {entry[InvoiceCells.DATE]?.header}: {entry[InvoiceCells.DATE]?.content}
            </small>
            {!!entry[InvoiceCells.ADDRESS]?.content && <small className="text-subdued">{entry[InvoiceCells.ADDRESS]?.content}</small>}
            {entry[InvoiceCells.AMOUNT]?.content}
          </div>

          {/* ACTIONS */}
          {!entry[InvoiceCells.PAYMENT_ACTION]?.hidden && !!entry[InvoiceCells.PAYMENT_ACTION]?.rawData && (
            <Link
              representation="button"
              isFullwidth
              as="a"
              target="_blank"
              href={entry[InvoiceCells.PAYMENT_ACTION].rawData}
              onNavigate={() => {
                trackEvent({ category: 'billing', object: 'pay_invoice', action: 'start' })
              }}
            >
              {t(($) => $.cells.payOnline)}
            </Link>
          )}

          <div className="flex-row gap-300">
            {!!pdfUrl && (
              <Link
                representation="button"
                isFullwidth
                variant="secondary"
                href={pdfUrl}
                leadingIcon={peppolUrl ? 'eyeOpen' : undefined}
                download
                as="a"
                target="_blank"
                rel="noopener noreferrer"
                onNavigate={() => trackEvent({ category: 'billing', object: 'download_invoice', action: 'click' }, { invoiceType: 'pdf' })}
              >
                {peppolUrl ? 'PDF' : t(($) => $.cells.viewPdf)}
              </Link>
            )}

            {!!peppolUrl && (
              <Link
                representation="button"
                isFullwidth
                variant="secondary"
                href={peppolUrl}
                download
                leadingIcon="download"
                as="a"
                target="_blank"
                rel="noopener noreferrer"
                onNavigate={() =>
                  trackEvent({ category: 'billing', object: 'download_invoice', action: 'click' }, { invoiceType: 'peppol' })
                }
              >
                Peppol
              </Link>
            )}
          </div>
        </>
      ) : null}
    </Modal>
  )
}

export default InvoiceEntryModal
